import { Component, computed, input } from '@angular/core';
import { LOADER_COLOR_CLASSES, LoaderColors, LoaderSize } from '../loaders.models';

const SIZE_CLASSES: Record<LoaderSize, string> = {
  sm: 'h-4 w-10',
  md: 'h-6 w-15',
  lg: 'h-8 w-20',
  xl: 'h-10 w-25',
};

@Component({
  selector: 'mib-dots-loader',
  templateUrl: './dots-loader.component.html',
  styleUrl: './dots-loader.component.css',
  host: {
    role: 'status',
    '[class]': 'hostClasses()',
    '[attr.aria-label]': 'label()',
  },
})
export class MibDotsLoaderComponent {
  /** Height of the row: `sm` 16, `md` 24, `lg` 32, `xl` 40px, two and a half times as wide. */
  readonly size = input<LoaderSize>('md');
  /** The colour of the dots; `light` is for a dark ground. */
  readonly color = input<LoaderColors>('primary');
  /** What a screen reader says while the loader is shown. */
  readonly label = input('Loading');

  /** The height and width classes of the dots for the current `size`. */
  readonly sizeClasses = computed(() => SIZE_CLASSES[this.size()]);
  /** The classes of the host, carrying the colour of the current `color`. */
  readonly hostClasses = computed(() => 'inline-flex ' + LOADER_COLOR_CLASSES[this.color()]);
}
